import * as React from 'react';

type PersonIconProps = {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
};

export function PersonIcon({
  size = 24,
  title = 'Person',
  className,
  style,
  color = 'currentColor',
}: PersonIconProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        overflow: 'hidden',
        lineHeight: 0,
        color,
        ...style,
      }}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 24 24'
        preserveAspectRatio='xMidYMid meet'
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        style={{display: 'block'}}
      >
        {/* Head */}
        <circle cx='12' cy='7' r='5' />
        {/* Eyes */}
        <line x1='10' y1='6.5' x2='10' y2='6.5' strokeWidth='1.8' strokeLinecap='round' />
        <line x1='14' y1='6.5' x2='14' y2='6.5' strokeWidth='1.8' strokeLinecap='round' />
        {/* Mouth */}
        <path d='M10.5 8.5 Q12 10 13.5 8.5' fill='none' />
        {/* Body */}
        <path d='M5 21v-1a7 7 0 0 1 14 0v1' />
      </svg>
    </span>
  );
}
